import { handleActions } from 'redux-actions';
import _ from 'lodash';
import qs from 'query-string';

export default handleActions({
  UPDATE_LOCATION: (state, { payload }) => ({
    ...state,
    q: _.get(qs.parse(payload.search), 'q', ''),
    videoType: _.get(qs.parse(payload.search), 'videoType', ''),
  }),
  TRACK_SEARCH: state => state,
}, {});



// WEBPACK FOOTER //
// ./src/reducer/search.js